const CustomInput = (
  { onFocus, value, disabled, className, onChange }: { onFocus?: any; value?: any; disabled?: boolean; className?: string; onChange?: any }
) => {
  return (
    <input
      id="date"
      name="date"
      placeholder="mm/dd/yyyy"
      onFocus={onFocus}
      value={value?.toString() ?? ''}
      className={className}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default CustomInput;
